import iconCaret from "../photos/caret.svg";
import { ListItem } from "./ListItem/ListItem";

const DISPLAY_ORDER = [0, 1, 2, 15, 17, 18, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 16];

const Recommendation = ({
  setOpenRecommendation,
  openRecommendation,
  setRoomInput,
  t,
  containerHeight,
}) => {
  const recs = t("rec", { returnObjects: true }) || [];

  return (
    <div style={{ marginBottom: "10px" }}>
      <div
        className="container-row top-margin-m"
        style={{ alignItems: "center" }}
      >
        <div
          className="container-row-start "
          onClick={() => setOpenRecommendation(!openRecommendation)}
        >
          <div className="text-h2">{t("tips")}</div>
          <img
            style={{
              paddingLeft: "16px",
              paddingRight: "16px",
              rotate: "180deg",
            }}
            src={iconCaret}
            alt=""
            className={
              openRecommendation
                ? "rotate top-margin-s"
                : "rotate-back top-margin-s"
            }
          />
        </div>
      </div>
      {openRecommendation && (
        <div
          style={{
            height: containerHeight - 500,
            overflow: "hidden",
            overflowY: "scroll",
          }}
          className={openRecommendation ? "recommendation-slide-in" : ""}
        >
          {DISPLAY_ORDER.map((idx) => {
            const rec = recs[idx];
            if (!rec) return null;
            return (
              <ListItem
                key={idx}
                recPreview={rec.preview}
                recText={rec.text}
                setRoomInput={setRoomInput}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Recommendation;
